import UpdateEvent from './UpdateEvent';
import { nextEventLoop } from '../Misc/timing';
import { getInstance } from './StateManager';

export const emitInput  = eventName => {
  return (instance, fn, descriptor) => {
    const initial = descriptor.value;
    
    descriptor.value = (...args) => {
      update(eventName, fn, args);
      console.log(initial, instance.subscriptions);
      return initial.call(instance, ...args);
    };
  }
};

export const emitOutput = eventName => {
  return (instance, fn, descriptor) => {
    const initial = descriptor.value;
    
    descriptor.value = (...args) => {
      const result = initial.call(instance, ...args);
      update(eventName, fn, result);
      return result;
    };
  }
};

export const emitMethod = (subject, eventName, method) => {
  emitMethods(subject, eventName, [method]);
}

export const emitMethods = (subject, eventName, fnList = []) => {
  fnList.forEach( fn => {
    const initial = subject[fn];
    subject[fn] = (...args) => {
      update(eventName, fn, args);
      try {
        return initial.call(subject, ...args);
      } catch(e) {
        console.error(e);
      }
    }
  });
}

export const update = (name, fn, args) => getInstance().update(new UpdateEvent(name, fn, args));


// WEBPACK FOOTER //
// ./src/Services/State/Emitter.js